import { DateTime } from "luxon";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { ChangeableFieldData } from "../../ChangeableFieldWidget";
import { DatePickerCell } from "../Cells/DatePickerCell";
import type { ChangeableFieldTableOptions } from "../ChangeableFieldTable";

function getEndDateColumn<T>(
  handleChangeEndDate: (index: number, newEndDate: DateTime | null) => void,
  tableOptions: ChangeableFieldTableOptions = {}
): MRT_ColumnDef<ChangeableFieldData<T>> {
  return {
    header: `Bis*`,
    accessorKey: "endDate",
    size: tableOptions.dateCellWidth ? tableOptions.dateCellWidth : 110,
    Cell: ({ cell, row }) => (
      <EndDateCell
        endDate={cell.getValue<DateTime | null>()}
        placeholder={tableOptions.endDatePlaceholder}
        restrictFutureDates={tableOptions.restrictFutureDates}
        startDate={row.original.startDate}
        onChange={(newEndDate) => handleChangeEndDate(row.index, newEndDate)}
      />
    )
  };
}

interface EndDateCellProps {
  endDate: DateTime | null;
  startDate: DateTime | null;
  placeholder?: string;
  restrictFutureDates?: boolean;
  onChange: (newEndDate: DateTime | null) => void;
}

function EndDateCell({
  endDate,
  startDate,
  placeholder = "Aktuell",
  restrictFutureDates,
  onChange
}: EndDateCellProps) {
  const firstPossibleDate = startDate ?? undefined;
  const lastPossibleDate = restrictFutureDates
    ? DateTime.now().minus({ days: 1 })
    : undefined;

  return (
    <DatePickerCell
      firstPossibleDate={firstPossibleDate}
      lastPossibleDate={lastPossibleDate}
      placeholder={!endDate ? placeholder : undefined}
      value={endDate ?? undefined}
      onChange={onChange}
    />
  );
}

export { getEndDateColumn };
